import React from 'react';
import si from 'si';
import Icon from '../Icons/Icon';
import moment from 'moment';
import 'idempotent-babel-polyfill';
import ReceiptActions from './ReceiptActions';
import { TextField } from '../FormFields/formFields';
import CreateAccountActions from './CreateAccountActions';
import CreateAccountStore from './CreateAccountStore';
moment.locale(window.jenkon.language);

export default class GuestOrderSummary extends React.Component {
    constructor(props) {
        super(props);
        this.backToForm = this.backToForm.bind(this);
        this.backToShop = this.backToShop.bind(this);
        this.state = {
            customerExists: false
        };
    }

    backToForm() {
        ReceiptActions.resetOrderDetail();
    }

    backToShop() {
        window.location = window.jenkon.consultantRoot + 'Products';
    }
    render() {
        return (
            <div className="site-container guest-receipt general animate-in" aria-live="assertive">
                <div className="section-wrapper clearfix">
                    <a href="javascript:void(0);" className="section-back-link receipt-link-back no-print" onClick={
                        this.backToForm} >&laquo; &nbsp;{this.props.resources["PWS.GuestCheckout.FindAnotherOrder"]}</a>
                </div>
                <div className="invoice-space"></div>
                <div className="section-wrapper clearfix">
                    <div className="receipt-title">{this.props.resources["PWS.GuestCheckoutReceipt.OrderConfirmation"]
                    }</div>
                </div>

                <div className="section-wrapper clearfix row">
                    <div className="col-sm-8 clearfix">
                        <div className="receipt-section-block">
                            <InvoiceHeader resources={this.props.resources} Header={this.props.Details.header
                            } Consultant={this.state} {...this.props} />
                        </div>
                        {!this.props.Details.header.customerExists &&
                            <div className="invoice-space"></div>
                        }
                        {!this.props.Details.header.customerExists &&
                            <div className="receipt-section-block no-print">
                                <CreateAccount resources={this.props.resources} Header={this.props.Details.header
                                } Consultant={this.state} {...this.props} />
                            </div>
                        }
                        <div className="invoice-space"></div>
                        <div className="receipt-section-block">
                            <CustomerInfo resources={this.props.resources} Header={this.props.Details.header
                            } shipToAddress={this.props.Details.shippingAddress} Consultant={this.state} {...this.props} />
                        </div>
                        {this.props.Details.shipments &&
                            <div className="invoice-space"></div>
                        }
                        {this.props.Details.shipments &&
                            <div className="receipt-section-block">
                                <Shipments resources={this.props.resources} Shipments={this.props.Details.shipments
                                } Items={this.props.Details.items} />
                            </div>
                        }
                        {this.props.Details.returns &&
                            <div className="invoice-space"></div>
                        }
                        {this.props.Details.returns &&
                            <div className="receipt-section-block">
                                <Returns resources={this.props.resources} ReturnList={this.props.Details.returns} />
                            </div>
                        }
                        <div className="invoice-space"></div>
                    </div>

                    <div className="col-sm-4 clearfix">
                        <div className="receipt-section-block">
                            <Products resources={this.props.resources} Header={this.props.Details.header} Items={this.props.Details.items} Consultant={this.state} {...this.props} />
                            <OrderTotals resources={this.props.resources} Totals={this.props.Details.totals} />
                        </div>
                    </div>
                </div>
                <div className="invoice-space"></div>
                <div className="section-wrapper clearfix row">
                    <div className="col-sm-8 clearfix">
                        <button className="receipt-button clearfix floatRight no-print" onClick={this.backToShop}>
                            {window.jenkon.resources["PWS.GuestCheckoutReceipt.ContinueButton"]}
                        </button>
                    </div>
                    <div className="col-sm-4 clearfix">&nbsp;</div>
                </div>
            </div>
        );
    }
}


class InvoiceUtilities extends React.Component {
    constructor(props) {
        super(props);
    }

    getFormattedPhone(phone) {
        if (!phone) phone = '';

        let cleanedPhone = ('' + phone).replace(/\D/g, '');
        let matched = cleanedPhone.match(/^(\d{3})(\d{3})(\d{4})$/);

        let formattedPhone = phone;
        if (phone.indexOf('-') == -1 && !!matched)
            formattedPhone = matched[1] + '-' + matched[2] + '-' + matched[3];

        return formattedPhone;
    }

}

class InvoiceHeader extends InvoiceUtilities {
    constructor(props) {
        super(props);
        this.printScreen = this.printScreen.bind(this);
    }

    printScreen() {
        window.print();
    }

    render() {
        let isGuestOrder = this.props.Header.customerName === this.props.Header.consultantName;
        let formattedPhone = this.getFormattedPhone(this.props.Details.shippingInstructions.phone);
        let message = this.props.resources["PWS.GuestCheckoutReceipt.Message"].replace("{0}", isGuestOrder ? this.props.Details.shippingInstructions.name : this.props.Header.customerName);

        return (
            <div className="invoice-header-wrapper clearfix">
                <div className="receipt-section-subtitle">{message}</div>
                <div className="invoice-space"></div>
                <div className="invoice-body-wrapper clearfix">
                    <div className="invoice-customer-id">
                        <strong>{this.props.resources['PWS.GuestCheckoutReceipt.OrderNumber']}&nbsp;{this.props.Header
                            .orderNumber}</strong>
                    </div>
                    <div className="invoice-date">
                        {this.props.resources["PWS.GuestCheckoutReceipt.OrderDate"]} {moment(this.props.Header
                            .orderDate).format('LLL')}
                    </div>
                    <div className="invoice-space"></div>
                    <div className="invoice-consultant-name">
                        {this.props.resources[`${this.props.isEnrollment
                            ? 'PWS.Enrollment.EnrollmentReceiptSponsorLabel'
                            : 'PWS.GuestCheckoutReceipt.ConsultantName'}`]} <span>{this.props.Header.consultantName
                                ? this.props.Header.consultantName
                                : this.props.Consultant.name}</span>
                    </div>
                    <div className="invoice-consultant-phone">
                        {this.props.resources["PWS.GuestCheckoutReceipt.Consultantphone"]} {this.props.Header.consultantPhone}
                    </div>
                </div>
                <div className="invoice-space"></div>
                <div>
                    {
                        this.props.Header.isParty
                            ? <div className="invoice-order-info">

                                <div className="invoice-partyName clearfix">
                                    {this.props.resources["PWS.MyAccount.PartyNameLabel"]}: {this.props.Header.partyName}
                                </div>
                                <div className="invoice-partyCode">
                                    {this.props.resources["PWS.MyAccount.PartyCodeLabel"]}: {this.props.Header.partyCode}
                                </div>
                                <div className="invoice-partyDate">
                                    {this.props.resources["PWS.MyAccount.PartyDateLabel"]}: {this.props.Header.partyDate}
                                </div>
                                <div className="invoice-hostName">
                                    {this.props.resources["PWS.MyAccount.HostNameLabel"]}: {this.props.Header.hostName}
                                </div>
                                <div className="invoice-hostPhone">
                                    {this.props.resources["PWS.MyAccount.HostPhoneLabel"]}: {this.props.Header.hostPhone}
                                </div>
                            </div>
                            : <div />
                    }
                </div>
                <div className="invoice-space"></div>
                <div>
                    <button className="receipt-button clearfix no-print" onClick={this.printScreen}>
                        {window.jenkon.resources["PWS.GuestCheckoutReceipt.Print"]}
                    </button>
                </div>
            </div>
        );
    }
}

class CreateAccount extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.state = {
            userNameEmail: props.Details.shippingInstructions.email,
            password: '',
            confirmPassword: '',
            accountHasError: false,
            emailExists: false,
            validEmail: true,
            validPassword: true,
            passwordExists: false
        };
    }

    componentDidMount() {
        CreateAccountStore.listen(this.onChange);
    }

    onChange(state) {
        this.setState(state);
    }

    handleChange(name, value) {
        var diff = {};
        diff[name] = value;
        this.setState(diff);
    }

    redirectLogin() {
        window.location = window.jenkon.consultantRoot + 'login';
    }

    registerErrors() {
        this.refs.userNameEmail.registerErrors();
        this.refs.password.registerErrors();
        this.refs.confirmPassword.registerErrors();
        this.isEmailValid();
        this.isPasswordValid();
    }

    isValid() {
        return (
            this.refs.userNameEmail.isValid()
            && this.refs.password.isValid()
            && this.refs.confirmPassword.isValid()
            && this.isEmailValid()
            && this.isPasswordValid()
        );
    }

    canSubmit() {
        return this.isValid();
    }

    checkEmailExists(value) {
        si.validateEmail(value, window.jenkon.country, window.jenkon.CustomerAccountType).then(this.returnEmailExists.bind(this), this.returnEmailExists.bind(this))
        if (this.state.password.length > 0) this.checkPasswordRules(this.state.password)
    }

    checkPasswordRules(value) {
        if (value && value.length > 0) {
            if (this.state.userNameEmail.length > 0 && this.state.validEmail)
                si.validatePasswordRequirements(this.state.userNameEmail, value).then(this.returnPasswordRequirements.bind(this), this.returnPasswordRequirements.bind(this))
        }
    }

    returnEmailExists(hasRecord) {
        this.setState({
            emailExists: typeof hasRecord === "boolean" ? !hasRecord : true,
            validEmail: typeof hasRecord === "boolean" ? hasRecord : false
        });
    }

    returnPasswordRequirements(hasRecord) {
        this.setState({
            passwordExists: typeof hasRecord === "boolean" ? !hasRecord : true,
            validPassword: typeof hasRecord === "boolean" ? hasRecord : false
        });
    }

    isEmailValid() {
        if (this.state.userNameEmail.length > 0 && !this.state.validEmail) {
            this.setState({
                emailExists: true
            });
        }
        return this.state.validEmail;
    }

    isPasswordValid() {
        if (this.state.password.length > 0 && !this.state.validPassword) {
            this.setState({
                passwordExists: true
            });
        }
        return this.state.validPassword;
    }

    submitAccount(name, phone, address, e) {

        let nameSplit = name ? name.split(' ') : '';
        let firstName = nameSplit.length > 0 ? nameSplit[0] : '';
        let lastName = nameSplit.length > 1 ? nameSplit[1] : '';

        let sendData = {
            FirstName: firstName,
            LastName: lastName,
            Username: this.state.userNameEmail,
            EmailAddress: this.state.userNameEmail,
            Password: this.state.password,
            EnrollingSponsor: window.jenkon.activityCenter,
            PlacementSponsor: window.jenkon.activityCenter,
            Language: window.jenkon.language,
            Country: window.jenkon.country,
            Culture: window.jenkon.culture,
            AccountType: window.jenkon.CustomerAccountType,
            Phone: phone,
            MainAddress: address
        }
        if (this.canSubmit()) {
            var self = this;
            si.validateEmail(self.state.userNameEmail, window.jenkon.country, window.jenkon.CustomerAccountType).then(function(hasRecord) {
                self.returnEmailExists(hasRecord);
                si.validatePasswordRequirements(self.state.userNameEmail, self.state.password).then(function(passHasRecord) {
                    self.returnPasswordRequirements(passHasRecord);
                    if (self.canSubmit()) {
                        CreateAccountActions.submitAccount(sendData);
                    }
                });
            });
        }
        else
            this.registerErrors();

        e.preventDefault();
        return false;
    }

    render() {
        let Rules = {
            userNameEmail: {
                required: true, requiredMessage: this.props.resources['PWS.Globals.Required'],
                email: true,
                emailMessage: this.props.resources['PWS.CreateAccountForm.EmailInvalidMessage']
            },
            password: { required: true, requiredMessage: this.props.resources['PWS.Globals.Required'] },
            confirmPassword: {
                required: true,
                requiredMessage: this.props.resources['PWS.Globals.Required'],
                mustMatch: () => {
                    return this.state.password;
                },
                mustMatchMessage: window.jenkon.resources["PWS.Enrollment.ConfirmPasswordDoesNotMatchMessage"]
            }
        }

        let errorDisplay = this.state.accountHasError ? <div className="login-error-message">{this.props.resources["PWS.CreateAccountForm.CreateAccountError"]}</div> : '';
        let displayEmailExistsError = this.state.emailExists ? <div className="login-error-message">{this.props.resources["PWS.CreateAccountForm.EmailExistsMessage"]}</div> : '';
        let displayPasswordRulesError = this.state.passwordExists ? <div className="login-error-message" dangerouslySetInnerHTML={{ __html: this.props.resources["PWS.CreateAccountForm.PasswordRulesError"] }}></div> : '';

        return (
            <div className="invoice-createaccount-wrapper clearfix" aria-live="polite">
                <div className="animate-in">
                    {this.state.accountCreated &&
                        <div className="field-container input-100">
                            <div>{this.props.resources["PWS.GuestCheckoutReceipt.AccountCreated"]}</div>
                            <div className="field-container input-100">
                                <button className="receipt-button clearfix no-print" onClick={this.redirectLogin.bind(
                                    this)}>
                                    {window.jenkon.resources["PWS.GuestCheckoutReceipt.LoginButton"]}
                                </button>
                            </div>
                        </div>
                    }
                    {!this.state.accountCreated &&
                        <form id="createaccount-form" method="post">
                            <div className="receipt-section-subtitle">{this.props.resources["PWS.GuestCheckoutReceipt.CreateAccountTitle"]}</div>
                            <div>{this.props.resources["PWS.GuestCheckoutReceipt.CreateAccountSubTitle"]}</div>
                            <div className="invoice-space"></div>
                            <div className="field-container input-100">
                                <TextField
                                    ref="userNameEmail"
                                    name="userNameEmail"
                                    classes="input-bordered input-50"
                                    handleChange={this.handleChange.bind(this)}
                                    handleBlur={this.checkEmailExists.bind(this)}
                                    label={this.props.resources["PWS.GuestCheckoutReceipt.UserName"]}
                                    modern={true}
                                    value={this.state.userNameEmail}
                                    Rules={Rules.userNameEmail}
                                />
                            </div>
                            <div className="field-container input-100">
                                <TextField
                                    ref="password"
                                    name="password"
                                    classes="input-bordered input-50"
                                    fieldType="password"
                                    handleChange={this.handleChange.bind(this)}
                                    handleBlur={this.checkPasswordRules.bind(this)}
                                    label={this.props.resources["PWS.GuestCheckoutReceipt.Password"]}
                                    modern={true}
                                    value={this.state.password}
                                    Rules={Rules.password}
                                />
                                <TextField
                                    ref="confirmPassword"
                                    name="confirmPassword"
                                    classes="input-bordered input-50"
                                    fieldType="password"
                                    handleChange={this.handleChange.bind(this)}
                                    label={this.props.resources["PWS.GuestCheckoutReceipt.ConfirmPassword"]}
                                    modern={true}
                                    value={this.state.confirmPassword}
                                    Rules={Rules.confirmPassword}
                                />
                            </div>
                            <div className="field-container input-100">
                                <button className="receipt-button clearfix no-print" onClick={this.submitAccount.bind(
                                    this,
                                    this.props.Details.shippingInstructions.name,
                                    this.props.Details.shippingInstructions.phone,
                                    this.props.Details.shippingAddress)}>
                                    {window.jenkon.resources["PWS.GuestCheckoutReceipt.CreateAccountButton"]}
                                </button>
                            </div>
                            <div className="field-container input-100">
                                {errorDisplay}
                                {displayEmailExistsError}
                                {displayPasswordRulesError}
                            </div>
                        </form>
                    }
                </div>
            </div>
        );
    }
}

class CustomerInfo extends InvoiceUtilities {
    constructor(props) {
        super(props);
    }

    createPaymentItems(payment, i) {
        return (
            <div key={i}>
                <div className="col-sm-6">
                    {payment.paymentType} - {payment.maskedCardNumber}
                </div>
                <div className="col-sm-6">
                    {payment.amount.displayValue}
                </div>
            </div>
        );
    }

    createVoucherItems(voucher, i) {
        return (
            <div key={i}>
                <div className="col-sm-6">
                    {voucher.voucherCode}
                </div>
                <div className="col-sm-6">
                    {voucher.localAmount.displayValue}
                </div>
            </div>
        );
    }

    render() {
        let isGuestOrder = this.props.Header.customerName === this.props.Header.consultantName;
        let customerName = isGuestOrder ? this.props.Details.shippingInstructions.name : this.props.Header.customerName;
        let formattedPhone = this.getFormattedPhone(this.props.Details.shippingInstructions.phone);
        let paymentStatus = (this.props.Details.creditCardPayments != null && this.props.Details.creditCardPayments.length > 0) ? this.props.Details.creditCardPayments[0].paymentStatus : '';

        let billingAddress = (this.props.Details.creditCardPayments != null && this.props.Details.creditCardPayments.length > 0) ? this.props.Details.creditCardPayments[0].billingAddress : null;

        return (
            <div className="invoice-header-wrapper clearfix">
                <div className="receipt-section-subtitle">{this.props.resources['PWS.GuestCheckoutReceipt.CustomerInfoTitle']}</div>
                <div className="invoice-space"></div>
                <div className="invoice-body-wrapper clearfix">
                    <div className="col-sm-6">
                        {this.props.resources['PWS.GuestCheckoutReceipt.CustomerName']}
                        <br />
                        {customerName}
                    </div>
                    <div className="col-sm-6">
                        {this.props.resources['PWS.GuestCheckoutReceipt.Email']}
                        <br />
                        {this.props.Details.shippingInstructions.email}
                    </div>
                </div>
                <div className="invoice-space"></div>
                <div className="invoice-body-wrapper clearfix">
                    <div className="col-sm-6">
                        {this.props.resources['PWS.GuestCheckoutReceipt.ShippingInfo']}
                        <div className="address">
                            {this.props.shipToAddress.line1}, {this.props.shipToAddress.line2 != null ? this.props.shipToAddress.line2 + ',' : null} <br />
                            {this.props.shipToAddress.city}, {this.props.shipToAddress.stateProvince} <br />
                            {formattedPhone}
                        </div>
                    </div>
                    <div className="col-sm-6">
                        {this.props.resources['PWS.GuestCheckoutReceipt.ShippingMethod']} <br />
                        {this.props.Header.shippingMethod}
                    </div>
                </div>
                {billingAddress && <div className="invoice-space"></div>}
                {billingAddress && (
                    <div className="invoice-body-wrapper clearfix">
                        <div className="col-sm-6">
                            {this.props.resources['PWS.GuestCheckoutReceipt.BillingInfo']}
                            <div className="address">
                                {billingAddress.addressLine1}, {billingAddress.addressLine2 != null && billingAddress.addressLine2 != '-' ? billingAddress.addressLine2 + ',' : null} <br />
                                {billingAddress.city}, {billingAddress.stateProvince}
                            </div>
                        </div>
                    </div>
                )}
                {this.props.Details.creditCardPayments && (
                    <div>
                        <div className="invoice-space"></div>
                        <div className="invoice-body-wrapper clearfix">
                            <div className="col-sm-6">{this.props.resources['PWS.GuestCheckoutReceipt.PaymentInfo']}</div>
                            <div className="col-sm-6">{this.props.resources['PWS.GuestCheckoutReceipt.PaymentAmount']}</div>
                            {this.props.Details.creditCardPayments && this.props.Details.creditCardPayments.map(this.createPaymentItems.bind(this))}
                        </div>
                        <div className="invoice-space"></div>
                        <div className="invoice-body-wrapper clearfix">
                            <div className="col-sm-6">
                                {this.props.resources['PWS.GuestCheckoutReceipt.PaymentStatus']}
                                <br />
                                {paymentStatus}
                            </div>
                        </div>
                    </div>
                )}
                <div className="invoice-space"></div>
                {this.props.Details.vouchers.length > 0 && (
                    <div className="invoice-body-wrapper clearfix">
                        <div className="col-sm-6">{this.props.resources['PWS.VoucherGrid.VoucherCode']}</div>
                        <div className="col-sm-6">{this.props.resources['PWS.VoucherGrid.Amount']}</div>
                        {this.props.Details.vouchers.map(this.createVoucherItems.bind(this))}
                    </div>
                )}
            </div>
        );
    }
}

class Products extends React.Component {
    constructor(props) {
        super(props);
    }

    createCartItemDetails(item, i) {
        let discount = item.discountAmount.amount > 0 ? item.discountAmount.displayValue : '';
        return (
            <div className="row receipt-product-row" key={i}>
                <div className="col-sm-3 receipt-productGridImage floatLeft"><img src={window.jenkon.imageEndpoint + item.productImageUrl} /></div>
                <div className="col-sm-6 receipt-product-details">
                    <div className="receipt-incart-description">
                        <span dangerouslySetInnerHTML={{ __html: item.inCartDescription }}></span>
                    </div>
                    <div className="receipt-incart-productcode">#{item.productCode}</div>
                    <div className="receipt-incart-qty">QTY: {item.quantityOrdered}</div>
                </div>
                <div className="col-sm-3 floatRight">
                    <div className="invoice-space"></div>
                    <div className="receipt-incart-discount">{discount}</div>
                    <div className="receipt-incart-price">{item.subtotal.displayValue}</div>
                </div>
            </div>
        );
    }

    render() {
        let totalItems = this.props.resources["PWS.GuestCheckoutReceipt.TotalItems"].replace("{0}", this.props.Items.length);
        return (
            <div className="invoice-header-wrapper clearfix">
                <div className="receipt-section-subtitle">{this.props.resources["PWS.GuestCheckoutReceipt.OrderDetailsTitle"]}</div>
                <div>({totalItems})</div>
                <div className="invoice-space"></div>
                <div className="col-sm-12" >
                    {this.props.Items.map(this.createCartItemDetails.bind(this))}
                </div>
            </div >
        );
    }
}

class OrderTotals extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let taxLabel = this.props.resources["GLOBAL.OrderTaxWithPercentageLabel.Label"].replace("{0}", this.props.Totals.taxPercentage.displayValue);

        return (
            <div>
                <hr />
                <div className="receipt-row-subtotal">
                    <div className="floatLeft">
                        {this.props.resources["PWS.GuestCheckoutReceipt.Subtotal"]}
                    </div>
                    <div className="floatRight">
                        {this.props.Totals.subtotal.displayValue}
                    </div>
                </div>
                <div className="receipt-row-subtotal">
                    <div className="floatLeft">
                        {this.props.resources["PWS.MyAccount.LessVouchersLabel"]}
                    </div>
                    <div className="floatRight">
                        {this.props.Totals.lessVouchers.displayValue}
                    </div>
                </div>
                <div className="receipt-row-subtotal">
                    <div className="floatLeft">
                        {this.props.resources["PWS.MyAccount.NetTotalLabel"]}
                    </div>
                    <div className="floatRight">
                        {this.props.Totals.netTotal.displayValue}
                    </div>
                </div>
                <div className="receipt-row-subtotal">
                    <div className="floatLeft">
                        {this.props.resources["PWS.GuestCheckoutReceipt.Shipping"]}
                    </div>
                    <div className="floatRight">
                        {this.props.Totals.freight.displayValue}
                    </div>
                </div>
                {
                    this.props.Totals.freightDiscount.amount != 0 &&
                    <div className="receipt-row-subtotal">
                        <div className="floatLeft">
                            {this.props.resources["PWS.MyAccount.FreightDiscountLabel"]}
                        </div>
                        <div className="floatRight">
                            -{this.props.Totals.freightDiscount.displayValue}
                        </div>
                    </div>
                }
                <div className="receipt-row-subtotal">
                    <div className="floatLeft">
                        {taxLabel}
                    </div>
                    <div className="floatRight">
                        {this.props.Totals.tax.displayValue}
                    </div>
                </div>
                <hr />
                <div className="receipt-row-total">
                    <div className="floatLeft">
                        {this.props.resources["PWS.GuestCheckoutReceipt.Total"]}
                    </div>
                    <div className="floatRight">
                        {this.props.Totals.total.displayValue}
                    </div>
                </div>
            </div>
        );
    }
}

class ListItem extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showReward: false,
            hasReward: props.rewardDescription != null && props.rewardDescription.length > 0 ? true : false
        }
    }

    showRewards() {
        this.setState({
            showReward: !this.state.showReward
        });
    }

    reward() {
        return (
            <div className="product-item-details clearfix" aria-live="polite">
                <div className="button-icon gift">
                    <Icon iconData={IconData} />
                </div>
                <div className="reward-description">
                    <span className="primary-text" style={{ fontWeight: 'bold' }}>{this.props.Item.rewardDescription}</span>
                </div>
            </div>
        );
    }

    formatAlternateCode(code) {
        if (code.indexOf('|') > -1) {
            return code.split('|')[0];
        }
        if (code.indexOf('-') > -1) {
            if (code.split('-').length === 3)
                return code.split('-')[1];
            else
                return code.split('-')[0];
        }

        return code.substring(0, Math.min(6, code.length));
    }

    render() {
        let IconData = {
            Fill: '#333',
            name: 'Gift',
            Size: 26
        }
        let productCode = this.props.Item.productAlternateCodes.length > 0 ? this.formatAlternateCode(this.props.Item.productAlternateCodes[0]) : this.props.Item.productCode;

        let rewards = this.state.hasReward ? <span className="product-down-arrow"></span> : null;
        let rewardClick = this.state.hasReward ? this.showRewards.bind(this) : () => { return false };
        let showReward = this.state.showReward ? this.reward() : null;
        return (
            <li>
                <a href="javascript:void(0);" role="button" className="product-item clearfix" onClick={rewardClick}>
                    <div className="product-id">{rewards} {productCode}</div>
                    <div className="product-name">{this.props.Item.productDescription}</div>
                    <div className="product-price">{this.props.Item.priceEach.displayValue}</div>
                    <div className="product-qty">x {this.props.Item.quantityOrdered}</div>

                    <div className="product-subtotal">{this.props.Item.subtotal.displayValue}</div>
                </a>
                {showReward}
            </li>
        );
    }
}

class ShippingAddress extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className='clearfix'>
                <div className="clearfix" tabIndex="0">
                    <div><strong tabIndex="0">{this.props.resources["PWS.MyAccount.ShippedToAddressLabel"]}:</strong></div>
                    <div className="address" tabIndex="0">
                        {this.props.shipToAddress.line1}, {this.props.shipToAddress.line2 != null ? this.props.shipToAddress.line2 + ',' : null} {this.props.shipToAddress.city} {this.props.shipToAddress.stateProvince} {this.props.shipToAddress.postalCode}
                    </div>
                </div>
            </div>
        );

    }
}

class Shipments extends React.Component {
    constructor(props) {
        super(props);
    }

    createIncludedItems(item, i) {
        let productCode = this.props.Items.filter(p => p.code === item.item)
        return (
            <li key={i}>
                <div className="shipped-item clearfix">
                    <div className="tracking-id">
                        {item.trackingUrl != null ? <a href={item.trackingUrl} target="_blank">{item.trackingNumbers}</a> : item.trackingNumbers}
                    </div>
                    <div className="product-id">{productCode.length > 0 ? productCode[0].productCode : null}</div>
                    <div className="product-name">{productCode.length > 0 ? productCode[0].productDescription : null}</div>
                    <div className="product-qty">{item.quantityShipped}</div>
                </div>
            </li>
        );
    }

    createShipmentHeaderInfo(ship) {
        return (
            <div className='clearfix'>
                <div className="clearfix" tabIndex="0">
                    <div><strong tabIndex="0">{this.props.resources["PWS.MyAccount.ShippedToNameLabel"]}:</strong></div>
                    <div className="address" tabIndex="0">
                        {ship.shipToName}
                    </div>
                </div>
                <div className="clearfix" tabIndex="0">
                    <div><strong tabIndex="0">{this.props.resources["PWS.MyAccount.ShippedToPhoneLabel"]}:</strong></div>
                    <div className="address" tabIndex="0">
                        {ship.shipToPhone}
                    </div>
                </div>
                <div className="clearfix" tabIndex="0">
                    <div><strong tabIndex="0">{this.props.resources["PWS.MyAccount.ShippedDeliveryInstructionsLabel"]}:</strong></div>
                    <div className="address" tabIndex="0">
                        {ship.specialDeliveryInstructions} &nbsp;
                    </div>
                </div>
                <div className="clearfix" tabIndex="0">
                    <div><strong>{this.props.resources["PWS.MyAccount.CarrierMethodLabel"]}: </strong></div>
                    <div>
                        <span>{ship.shippingCarrierShippingMethod} {this.props.resources["PWS.Enrollment." + ship.shippingCarrierShippingMethod]}</span><br /><br />
                    </div>
                </div>
                <div className="clearfix" tabIndex="0">
                    <div><span>{ship.deliveryDaysMessage}</span></div>
                </div>
            </div>
        );
    }

    createShipmentHeaderReferenceInfo(ship) {
        return (
            <div className="clearfix">
                <div className="clearfix" tabIndex="0">
                    <div><strong tabIndex="0">{this.props.resources["PWS.MyAccount.ShippedReference"]}:</strong></div>
                    <div className="address" tabIndex="0">
                        {ship.trackingId}
                    </div>
                </div>
                <div className="clearfix" tabIndex="0">
                    <div><strong>{this.props.resources["PWS.MyAccount.ShippedOnLabel"]}: </strong></div>
                    <div tabIndex="0">{moment(ship.shipDate).format('LL')}</div>
                </div>
            </div>
        );
    }

    createShipmentItemTable(ship) {
        let shippedItems = ship.items.filter(s => s.quantityShipped != 0);
        return (
            <div>
                <div className="shipped-items-wrapper clearfix">
                    <div className="shipped-on clearfix">
                        {this.createShipmentHeaderReferenceInfo(ship)}
                    </div>

                    <div className="shipped-to clearfix">
                        <div className="shipped-items-list clearfix">
                            <div className="column-header shipped-item clearfix">
                                <div className="tracking-id">{this.props.resources["PWS.MyAccount.TrackingIDLabel"]}</div>
                                <div className="product-id">{this.props.resources["PWS.MyAccount.OrderSummaryShippedItemCode"]}</div>
                                <div className="product-name">{this.props.resources["PWS.MyAccount.OrderSummaryShippedItemDescription"]}</div>
                                <div className="product-qty">{this.props.resources["PWS.MyAccount.OrderSummaryShippedItemQuantity"]}</div>
                            </div>
                            <ul className="" aria-live="polite">
                                {shippedItems.map(this.createIncludedItems.bind(this))}
                            </ul>
                        </div>
                    </div>
                </div>

                <br />
            </div>
        );
    }

    render() {
        if (this.props.Shipments == null || this.props.Shipments.length == 0) return null;
        return (
            <div>
                <div className="wrapper clearfix">
                    <div className="shipped-on clearfix">
                        <div className="receipt-section-subtitle">{this.props.resources["PWS.MyAccount.OrderSummaryShipmentsTitle"]}</div>
                    </div>
                    <div className="shipped-to clearfix">
                        <div className="invoice-section-title">{this.props.resources["PWS.MyAccount.OrderSummaryShippedItemsTitle"]}</div>
                    </div>
                </div>

                <div>
                    <div className="wrapper clearfix">
                        <div className="shipped-on clearfix">
                            {this.createShipmentHeaderInfo(this.props.Shipments[0])}
                        </div>
                        <div className="shipped-to clearfix">
                            {this.props.Shipments.map(this.createShipmentItemTable.bind(this))}
                        </div>
                    </div>

                    <div className="spacer12"></div>
                </div>

                <div className="dotted-HR"></div>
                <div className="spacer12"></div>
            </div>
        );
    }
}

class Returns extends React.Component {
    constructor(props) {
        super(props);
    }


    createItems(Return, i) {
        return <ReturnItem key={Return.returnId} Return={Return} resources={this.props.resources} />
    }

    render() {
        if (this.props.ReturnList == null || this.props.ReturnList.length == 0) return false;
        return (
            <div className="invoice-body-wrapper clearfix">
                <div className="receipt-section-subtitle">{this.props.resources["PWS.MyAccount.ReturnTitle"]}</div>
                <div className="invoice-returns">
                    <div className="data-column-header">
                        <div>{this.props.resources["PWS.MyAccount.ReturnIDLabel"]}</div>
                        <div>{this.props.resources["PWS.MyAccount.ReturnDateLabel"]}</div>
                        <div>{this.props.resources["PWS.MyAccount.ReturnActionLabel"]}</div>
                        <div>{this.props.resources["PWS.MyAccount.ReturnProductLabel"]}</div>
                    </div>
                    {this.props.ReturnList.map(this.createItems.bind(this))}
                </div>
                <div className="spacer12"></div>
                <div className="dotted-HR"></div>
                <div className="spacer12"></div>
            </div>
        );
    }
}

class ReturnItem extends React.Component {
    constructor(props) {
        super(props);
    }

    createProductCodes(code, i) {
        return `${code}${(i + 1) == this.props.Return.productCodes.length ? '' : ','} `;
    }

    render() {

        return (
            <div className="data-row clearfix" aria-live="polite">
                <div className="return-link">{this.props.Return.returnId}</div>
                <div className="return-date">{moment(this.props.Return.date).format('LLL')}</div>
                <div className="return-action">{this.props.Return.action}</div>
                <div className="return-products">{this.props.Return.productCodes.map(this.createProductCodes.bind(this))}</div>
            </div>
        );
    }
}

GuestOrderSummary.defaultProps = {
    Details: {}
}



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/GuestCheckout/GuestOrderSummary.js